/* eslint-disable react/no-array-index-key */
import { ReactElement, Fragment } from 'react';
import { useLocation } from 'react-router-dom';
import { ProgressStep } from '@constants';
import { iFormMetaData } from '@interfaces/interfaces';
import classnames from 'classnames';
import { ReactComponent as DoneIcon } from '../../images/done.svg';
import styles from './ProgressBar.module.scss';

interface iProgressBar {
  formMetaData: iFormMetaData;
}

const ProgressBar = ({ formMetaData }: iProgressBar): ReactElement => {
  const location = useLocation();
  const titles = [ProgressStep.START, ProgressStep.DETAILS, ProgressStep.CHECK_CONFIRM, ProgressStep.DONE];

  let lastSegment = location.pathname.substring(location.pathname.lastIndexOf('/') + 1);
  if (!lastSegment.includes('step')) {
    lastSegment = 'step1';
  }
  const currentStep = formMetaData.pagesSegments[lastSegment].progressStep;

  return (
    <div className={styles.container}>
      <div className={styles.bar}>
        {titles.map((title, index) => {
          const tileSelected = currentStep === title;
          return (
            <Fragment key={index}>
              <div
                className={classnames({
                  [styles.step]: true,
                  [styles.selected]: tileSelected && currentStep !== ProgressStep.DONE,
                  [styles.done]: tileSelected && currentStep === ProgressStep.DONE,
                  [styles.removeFirstArrow]: currentStep !== ProgressStep.START,
                  [styles.donePrev]: title === ProgressStep.CHECK_CONFIRM && currentStep === ProgressStep.DONE,
                })}>
                <div className={styles.content}>
                  {index === titles.length - 1 && currentStep === ProgressStep.DONE && <DoneIcon />}
                  <span className={classnames({
                    [styles.text]: true,
                    [styles.textGrey]: titles.slice(titles.indexOf(currentStep)).indexOf(title) === -1,
                  })}>
                    {title}
                  </span>
                </div>
              </div>
            </Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressBar;
